import {ImageMetaData, ItemData} from '../interfaces/planogram.interface';

export function isLodItem(item: ItemData): item is ItemData<ImageMetaData> {
  return item.lods !== undefined;
}
